import * as cheerio from "cheerio";
import { wrapInnerLink } from "./inner-link";
import { wrapReference } from "./wrap-reference";
import { wrapChat } from "./wrap-chat";

export interface ProcessArgs {
  content: Queries.Maybe<string>;
  references: Queries.MicrocmsPost[];
}

export async function process(args: ProcessArgs): Promise<string> {
  const { content } = args;
  if (!content) return "";

  const $ = cheerio.load(content);

  $("a").each((_, element) => {
    $(element).addClass("underline");
  });

  $("p").each((_, element) => {
    $(element).addClass("py-2");
  });

  $("h2").each((_, element) => {
    $(element).addClass("border-l-4 border-primary font-bold px-2 text-xl");
    $(element).wrap(
      "<div class='pt-4'style='padding: 24px 0px 6px 0px;'></div>",
    );
  });

  $("h3").each((_, element) => {
    $(element).addClass(
      "border-l-4 border-primary/[.80] font-bold px-2 text-lg",
    );
    $(element).wrap(
      "<div class='pt-4'style='padding: 12px 0px 4px 0px;'></div>",
    );
  });

  $("h4").each((_, element) => {
    $(element).addClass("border-l-4 border-primary/[.60] font-bold px-2");
    $(element).wrap(
      "<div class='pt-4'style='padding: 12px 0px 4px 0px;'></div>",
    );
  });

  $("figure").each((_, element) => {
    $(element).addClass("py-6");
  });

  $("img").each((_, element) => {
    $(element).addClass("rounded-md");
  });

  $("table").each((_, element) => {
    $(element).addClass("table table-xs sm:table-md w-full");
    $(element).wrap(
      '<div class="overflow-x-auto" style="margin: 10px 0"></div>',
    );
  });

  $("th").each((_, element) => {
    $(element).addClass("bg-primary/[.20]");
  });

  $("tr").each((_, element) => {
    $(element).addClass("hover");
  });

  $("ul").each((_, element) => {
    $(element).addClass("list-disc list-inside py-2 px-2");
  });

  $("li > ul").each((_, element) => {
    $(element).removeClass("py-2");
  });

  $(".reference").each((_, element) => wrapReference(element, args));
  $(".wienpedia-reference").each((_, element) => wrapInnerLink(element, args));

  $(".k2ek1e-chat").each((_, element) => wrapChat(element, "k2ek1e", args));
  $(".uc6o6u5co-chat").each((_, element) =>
    wrapChat(element, "uc6o6u5co", args),
  );

  return $.html();
}

export interface Heading {
  id: string;
  text: string;
  level: number;
  children: Heading[];
}

/**
 * Retrieves the table of contents from the content.
 */
export function toc(content: string): Heading[] {
  const $ = cheerio.load(content);
  const headings: Heading[] = [];
  const stack: Heading[] = [];

  // h1 is the title of the page, so we start at h2
  $("h2, h3, h4, h5, h6").each((_, element) => {
    const level = Number($(element).prop("tagName").slice(1));
    const id = $(element).attr("id");
    if (!id) return;
    const text = $(element).text();
    const heading: Heading = { level, id, text, children: [] };

    while (stack.length > 0 && level <= stack[stack.length - 1].level) {
      stack.pop();
    }

    if (stack.length === 0) {
      headings.push(heading);
    } else {
      stack[stack.length - 1].children.push(heading);
    }

    stack.push(heading);
  });

  return headings;
}

export default {
  process,
  toc,
};
